import { ExtendedUsp, Product } from '@features/product/typings';

const FREE_SALES_PRICE = 0;
const PLACE_AND_CONNECT = 15;

export const GetPreSelectedServiceUsps = (services: Product['services']): ExtendedUsp[] => {
  if (services.length === 0) {
    return [];
  }

  const preSelectedService =
    services.findLast(
      service =>
        service.salesPrice.includingVat === FREE_SALES_PRICE &&
        service.installServiceTypeId === PLACE_AND_CONNECT
    ) ?? services.find(service => service.isPreselected);

  if (!preSelectedService || !preSelectedService.extendedUsps) {
    return [];
  }

  return preSelectedService.extendedUsps;
};
